import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBusiness } from "constants/apiUrls";
const businessApi = createApi({
  reducerPath: "business",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_URL }),
  endpoints: (builder) => ({
    business: builder.query<BusinessType, { token?: string; uuid: string }>({
      query: (arg) => {
        const { token, uuid } = arg;
        const mandatoryHeaders = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            token || JSON.parse(localStorage.getItem("token") || "")
          }`,
        };
        return {
          url: getBusiness(uuid),
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useBusinessQuery, useLazyBusinessQuery } = businessApi;
export default businessApi;
